import React, { useRef } from "react";

const DishPreview = ({ selectedItems, onRemoveItem, onReorder }) => {
  const thaliRef = useRef(null);

  // --- NEW CATEGORY MAPPING BASED ON menuStructure ---
  
  // 1. Items that go ON the plate (Main Course components)
  const mainCourseTypes = [
    "Regular_Veg", "Gujarati_shak", "Kathiyawadi_Shak", "Premium_veg",
    "Regular_sweet", "liquid_sweet", "Premium_Sweet", 
    "Dal", "Rice", "Regular_bread", "premium_bread"
  ];

  // 2. Grouping for Side Zones
  const starterItems = selectedItems.filter(item => 
    ["Soups", "premium_Soups", "Starters", "Premium_starters"].includes(item.type)
  );

  const drinkItems = selectedItems.filter(item => 
    ["juice", "Water", "Drinks"].includes(item.type) // Including common defaults
  );

  const liveCounterItems = selectedItems.filter(item => 
    ["Chinese_Live", "South_Indian_Live", "Chaat_Live", "Back_Dish", "premium_live"].includes(item.type)
  );

  const plateItems = selectedItems.filter(item => mainCourseTypes.includes(item.type));

  // Any extra items that don't fit above (Salads, Papad, etc. if added later)
  const extraTreats = selectedItems.filter(item => 
    !mainCourseTypes.includes(item.type) && 
    !["Soups", "premium_Soups", "Starters", "Premium_starters", "juice", "Chinese_Live", "South_Indian_Live", "Chaat_Live", "Back_Dish", "premium_live"].includes(item.type)
  );

  // --- DRAG HANDLERS ---
  const handleDragStart = (e, itemId) => {
    e.dataTransfer.setData("itemId", itemId);
    e.dataTransfer.effectAllowed = "move";
    e.target.style.opacity = "0.5";
  };

  const handleDragEnd = (e) => {
    e.target.style.opacity = "1";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e, targetId) => {
    e.preventDefault();
    const draggedId = e.dataTransfer.getData("itemId");
    if (draggedId && draggedId.toString() !== targetId.toString()) {
      onReorder(draggedId, targetId);
    }
  };

  return (
    <div className="preview-container" style={{ width: '100%', display: 'flex', justifyContent: 'center', userSelect: 'none', padding: '20px' }}>
      <div className="capture-wrapper" ref={thaliRef} style={tableStyles}>
        
        {/* SIDE BOXES */}
        {renderZone("top-left", "Starters & Soups", starterItems, onRemoveItem)}
        {renderZone("top-right", "Juices & Drinks", drinkItems, onRemoveItem)}
        {renderZone("bottom-left", "Live Counters", liveCounterItems, onRemoveItem)}
        {renderZone("bottom-right", "Other Add-ons", extraTreats, onRemoveItem)}

        {/* THE MAIN PLATE */}
        <div className="thali-main" style={plateContainerStyles}>
          <img 
            src="/assets/img/customize/Dish3.png" 
            className="plate-bg" 
            alt="Plate" 
            style={{ width: '100%', height: '100%', pointerEvents: 'none' }} 
          />
          
          <div className="food-positioner" style={foodLayerStyles}>
            
            {/* --- NEW LOGO LOGIC --- */}
            {plateItems.length === 0 && (
              <div style={logoContainerStyles}>
                <img 
                  src="/assets/img/logo/1.png" // Path to your logo
                  alt="Restaurant Logo" 
                  style={logoImgStyles} 
                />
                {/* <p style={{ color: 'rgba(255,255,255,0.5)', marginTop: '10px', fontSize: '14px' }}>
                  Select items to fill your plate
                </p> */}
              </div>
            )}

            {plateItems.map((item, index) => {
              const total = plateItems.length;
              let x, y, size;
              
              // ... (Keep your existing circular logic here)
              if (index === 0 && total > 1) {
                x = 50; y = 50; size = 28;
              } else {
                const adjTotal = total > 1 ? total - 1 : total;
                const adjIndex = total > 1 ? index - 1 : index;
                const angle = (adjIndex / adjTotal) * 2 * Math.PI - Math.PI / 2;
                const radius = 28; 
                x = total > 1 ? 50 + radius * Math.cos(angle) : 50;
                y = total > 1 ? 50 + radius * Math.sin(angle) : 50;
                size = total > 8 ? 15 : 22;
              }

              return (
                <div
                  key={item.id}
                  className="bowl-slot"
                  draggable="true"
                  onDragStart={(e) => handleDragStart(e, item.id)}
                  onDragEnd={handleDragEnd}
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDrop(e, item.id)}
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveItem(item.id);
                  }}
                  style={{ 
                    ...bowlStyles,
                    left: `${x}%`, 
                    top: `${y}%`, 
                    width: `${size}%`, 
                    height: `${size}%`,
                    zIndex: index === 0 ? 11 : 12,
                  }}
                >
                  <img 
                    src={item.image} 
                    alt={item.name} 
                    style={{ width: '100%', borderRadius: '50%', pointerEvents: 'none' }} 
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

// --- HELPER COMPONENTS & STYLES ---

const renderZone = (posClass, label, items, onRemove) => {
  if (items.length === 0) return null;
  return (
    <div className={`table-zone ${posClass}`} style={zoneStyles}>
      <span style={labelStyles}>{label}</span>
      <div style={gridStyles}>
        {items.map(item => (
          <div key={item.id} style={{ position: 'relative' }}>
            <img 
              src={item.image} 
              className="side-img" 
              onClick={() => onRemove(item.id)} 
              alt={item.name} 
              title={item.name}
              style={sideImgStyles}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const tableStyles = {
  position: 'relative',
  width: '1000px',
  height: '800px',
  backgroundImage: 'url(/assets/img/wood_texture.jpg)',
  backgroundSize: 'cover',
  borderRadius: '20px',
  // boxShadow: 'inset 0 0 100px rgba(0,0,0,0.5), 0 20px 40px rgba(0,0,0,0.4)',
  overflow: 'hidden'
};

const plateContainerStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '580px',
  height: '580px',
  zIndex: 5 
};

const foodLayerStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 10 
};

const bowlStyles = {
  position: 'absolute', 
  transform: 'translate(-50%, -50%)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', 
  cursor: 'grab', 
  pointerEvents: 'auto'
};

const zoneStyles = {
  position: 'absolute',
  padding: '15px',
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  borderRadius: '12px',
  backdropFilter: 'blur(5px)',
  border: '1px solid rgba(255,255,255,0.2)',
  minWidth: '180px'
};

const labelStyles = {
  display: 'block',
  color: '#fff',
  fontSize: '14px',
  fontWeight: 'bold',
  marginBottom: '10px',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  borderBottom: '1px solid gold'
};

const gridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '10px'
};

const sideImgStyles = {
  width: '50px',
  height: '50px',
  borderRadius: '8px',
  cursor: 'pointer',
  objectFit: 'cover',
  boxShadow: '0 4px 6px rgba(0,0,0,0.2)'
};

const logoContainerStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  opacity: 0.8 // Makes it look subtle on the plate
};

const logoImgStyles = {
  width: '400px', // Adjust size based on your logo design
  height: '200px',
  filter: 'grayscale(20%) contrast(90%)', // Optional: gives it a slightly "etched" look on the plate
};

export default DishPreview;